import React, { useEffect } from 'react'
import { SITE_BASE_URL } from '../../Components/common/constants'

const Welcome = () => {

  useEffect(() => {
    document?.title && (document.title = `LifeTab`);
  }, [])

  return (
    <div className='welcome-body right-0'>
      <span style={{flex: 1}}></span>
      <h1>Welcome to LifeTab</h1>
      <p>Your new life dashboard will appear in just a moment. First, we need to get you signed up.</p>
      <div className='flex items-center justify-center gap-[10px]'>
        <a href={`${SITE_BASE_URL}/signup`} className='btn primary'>Sign Up</a>
        <a href={`${SITE_BASE_URL}/login`} className='btn'>Log In</a>
      </div>
    </div>
  )
}

export default Welcome